import React, { Component } from 'react';

class ToggleBtn extends Component{
    constructor(props) {
        super(props);

        this.state = {}
        
        this.changeToggle = this.changeToggle.bind(this);
    }
   
    componentDidMount(){}

    changeToggle(item){
        try {
            var tmpEvent = { target:{ name: this.props.name, value: item }};
            this.props.handleChange(tmpEvent);
        }
        catch(ex){
            console.log(" [Error] Changing Toggle: ",ex);
        }
    }

    render(){        
        return(
            <div className="toggle-btn-container">
                {this.props.toggles.map((item,i) =>
                    <div className={"toggle-btn" +(this.props.selected === item ? " sel":"")} key={i} onClick={()=> this.changeToggle(item)}>{item}</div>
                )}
            </div>
        );        
    }
}

export default ToggleBtn;